import RefundService from "../services/refund.service";

const state = {
	saleLists: [],
	zLists: [],
	zReports: [],
	zReportsTotal: 0,
	items: [],
	status: "fail",
	lastSelectedDeps: [],
	lastCurrentPage: 1,
	lastFilterData: {}
};

const getters = {
	getSales(state) {
		return state.saleLists;
	},
	getZrepot(state) {
		return state.zLists;
	},
	getStatus(state) {
		return state.status
	}
};


const actions = {
	async fetchRetailReturnSales({commit}, data) {
		try {
			commit('setSaleList', []);
			const sales = await RefundService.fetchRetailReturnSales(data)

			commit('setSaleList', sales.data);
			return true
		} catch (e) {
			return false
		}
	},
	async fetchWholeReturnSales({commit}, data) {
		try {
			commit('setSaleList', []);
			const sales = await RefundService.fetchWholeReturnSales(data)
			commit('setSaleList', sales.data);
			return true
		} catch (e) {
			return false
		}
	},
	async saveSelectedDeps({commit}, filterPayloadToSave) {
		await commit('setSelectedDeps', filterPayloadToSave);
	},
	async getSaleLists({commit}, data) {
		try {
			const sales = await RefundService.getSaleList(data)
			commit('setSaleList', sales.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getZochot({commit}, data) {
		try {
			const sales = await RefundService.getZochot(data)
			commit('setZochot', sales.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getOptomSaleLists({commit}, data) {
		try {
			const sales = await RefundService.getOptomSaleList(data)
			commit('setSaleList', sales.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getZreportsList({commit}, data) {
		try {
			const response = await RefundService.zReportsList(data)
			commit('setZreports', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getItemsFromId({commit}, data) {
		try {
			const items = await RefundService.getItems(data)
			commit('setItems', items.data);
			return true
		} catch (e) {
			return false
		}
	},
	async setRefound({commit}, payload) {
		try {
			const status = await RefundService.refoundSet(payload)
			commit('setStatus', status);
			return true
		} catch (e) {
			return false
		}
	},
};

const mutations = {
	setSelectedDeps(state, filterPayloadToSave) {
		state.lastFilterData = filterPayloadToSave;
		state.lastSelectedDeps = filterPayloadToSave.selectedDepartment;
		state.lastCurrentPage = filterPayloadToSave.currentPage;
	},
	resetSales(state, emptyArray) {
		state.saleLists = emptyArray;
	},
	setSaleList(state, sales) {
		state.saleLists = sales;
	},
	setZochot(state, sales) {
		state.zLists = sales;
	},

	setZreports(state, zReports) {
		state.zReports = zReports.items;
		state.zReportsTotal = zReports.total;
	},
	resetZReports(state) {
		state.zReports = [];
		state.zReportsTotal = 0;
	},
	setItems(state, data) {
		state.items = data
	},
	setStatus(state, status) {
		state.status = status
	}
};

export const refunds = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
